import { FolderKanban, ListChecks, Rows3 } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const projectsNavigation: NavItem[] = [
  {
    to: '/projects',
    labelKey: 'nav.projects',
    group: 'nav.groups.support',
    icon: FolderKanban,
    permission: 'projects.view',
  },
  {
    to: '/projects/sprints',
    labelKey: 'nav.sprints',
    group: 'nav.groups.support',
    icon: Rows3,
    permission: 'projects.view',
  },
  {
    to: '/projects/tasks',
    labelKey: 'nav.tasks',
    group: 'nav.groups.support',
    icon: ListChecks,
    permission: 'projects.view',
  },
]
